import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('pintendre');

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A spacious rural residential property in Quebec with a single-family house and detached garage on a large lot, open countryside view, metal and asphalt shingle roofing, wide green lawn, trees in background, bright daylight, authentic rural Quebec photography style, warm earth tones with slate blue sky and copper roof accents on vents"
          alt="Toiture résidentielle à Pintendre, Lévis — couvreur partenaire RBQ sur grand terrain"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1B2A4E]/70 via-[#1B2A4E]/50 to-[#1B2A4E]/75" />
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-24 md:pt-28 pb-16 md:pb-20">
        <nav className="text-sm text-white/70 mb-6 flex items-center gap-2 flex-wrap">
          <Link to="/" className="hover:text-[#C77D3F] transition-colors">{t('breadcrumb_home')}</Link>
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </span>
          <span className="text-white/50">{t('breadcrumb_sectors')}</span>
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </span>
          <span className="text-white font-medium">{t('breadcrumb_current')}</span>
        </nav>

        <h1 className="text-[40px] md:text-[52px] font-bold text-white leading-tight mb-4 md:mb-5 max-w-4xl">
          {t('hero_h1')}
        </h1>

        <p className="text-base md:text-lg text-white/85 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          {t('hero_subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-10 md:mb-12">
          <Link
            to="/soumission-gratuite"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-[#C77D3F] text-white font-semibold rounded-md hover:bg-[#b56d32] transition-colors whitespace-nowrap text-base"
          >
            {t('hero_cta')}
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-white/75 text-sm">
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center text-[#C77D3F]">
              <i className="ri-check-line" />
            </span>
            <span>{t('hero_stat_1')}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center text-[#C77D3F]">
              <i className="ri-check-line" />
            </span>
            <span>{t('hero_stat_2')}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center text-[#C77D3F]">
              <i className="ri-check-line" />
            </span>
            <span>{t('hero_stat_3')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}